import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import appActions from '../../../appActions';
import { dateTimeTemplate, fileGroupOptions, statusOptions, yesNoOptions } from '../../../utils/mics';
import DownloadFile from '../../../components/DownloadFile';
import { Toast } from 'primereact/toast';

const IntOutBoundFileDetail = () => {

    const toast = useRef(null)

    const { state } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    //const intOutBoundFile = useSelector((state) => state.intOutBoundFile.intoutboundfile);

    const [record, setRecord] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);
    const [isViewMode, setIsViewMode] = useState(false);

    useEffect(() => {
        if (!state) return;
        const { data, isView, isEdit } = state;
        setRecord(data || {});
        setIsViewMode(isView || false);
        setIsEditMode(isEdit || false);
    }, [state]);

    const handleSubmit = (data) => {
        if (data.id) {
            dispatch(appActions.INTOUTBOUNDFILE_UPDATE_REQUEST(data));
        } else {
            dispatch(appActions.INTOUTBOUNDFILE_CREATE_REQUEST(data));
        }
      
    };

    // useEffect(() => {
    //     if (intOutBoundFile?.action === 'create' || intOutBoundFile?.action === 'update') {
    //         handleRedirect();
    //     }
    // }, [intOutBoundFile]);

    const formik = useFormik({
        initialValues: {
            id: record?.id || '',
            storeId: record?.storeId || '',
            fileId: record?.fileId || '',
            businessDate: record?.businessDate || '',
            beginDateTime: record?.beginDateTime || '',
            endDateTime: record?.endDateTime || '',
            inFilePath: record?.inFilePath || '',
            outFilePath: record?.outFilePath || '',
            xmlStatus: record?.xmlStatus || null,
            logText: record?.logText || '',
            error: record?.error || null,
            fileType: record?.fileType || null,
            lastUpdatedBy: record?.lastUpdatedBy || '',
            createdOn: dateTimeTemplate(record?.createdOn) || '',
            lastUpdated: dateTimeTemplate(record?.lastUpdated) || '',
            status:
                record && record.status
                    ? statusOptions.find(
                          (status) => status.code === record.status,
                      )
                    : statusOptions.find((status) => status.code === 'Active'),
        },
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};
            return errors;
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                status: values.status.code ? values.status.code : '',
            };
            if (isEditMode) {
                data['id'] = record.id;
            }
            handleSubmit(data);
        },
    });

    const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

   

    const renderFormArea = () => {
        return (
            <div className="p-fluid formgrid grid br-2 bg-white p-2 py-2 border-round-xl shadow-1">
                {(isEditMode || isViewMode) && (
                    <div className="col-4 mb-3">
                        <label htmlFor="id">Id</label>
                        <InputText id="id" name="id" value={formik.values.id} onChange={formik.handleChange} disabled />
                    </div>
                )}

                <div className="col-4 mb-3">
                    <label htmlFor="storeId">File Id</label>
                    <InputText id="fileId" name="fileId" value={formik.values.fileId} onChange={formik.handleChange} />
                </div>

                <div className="col-4 mb-3">
                    <label htmlFor="storeId">Store Id </label>
                    <InputText id="storeId" name="storeId" value={formik.values.storeId} onChange={formik.handleChange} />
                </div>
               
                <div className="col-4 mb-2">
                    <label htmlFor="fileType">File Type</label>
                     <Dropdown filter showClear  value={formik.values.fileType}
                        onChange={formik.handleChange} options={fileGroupOptions} 
                        id="fileType" name="fileType" optionLabel="name" optionValue='name'
                        className={classNames({
                            'p-invalid': isFormFieldValid('fileType'),
                        })}
                        disabled={isViewMode} />
                    {getFormErrorMessage('fileType')}
                </div>
                
                <div className="col-4 mb-3">
                    <label htmlFor="businessDate"> Business Date </label>
                    <InputText id="businessDate" name="businessDate" value={formik.values.businessDate} onChange={formik.handleChange} readOnly={isViewMode} />
                </div>

                <div className="col-4 mb-3">
                    <label htmlFor="beginDateTime"> Begin Date Time </label>
                    <InputText id="beginDateTime" name="beginDateTime" value={formik.values.beginDateTime} onChange={formik.handleChange} readOnly={isViewMode} />
                </div>

                <div className="col-4 mb-3">
                    <label htmlFor="endDateTime"> End Date Time </label>
                    <InputText id="endDateTime" name="endDateTime" value={formik.values.endDateTime} onChange={formik.handleChange} readOnly={isViewMode} />
                </div>

                <div className="col-4 mb-3">
                    <label htmlFor="processed">Xml Status </label>
                     <Dropdown filter showClear id="xmlStatus" name="xmlStatus" value={formik.values.xmlStatus} onChange={formik.handleChange} optionLabel="name" optionValue='code' options={yesNoOptions} disabled={isViewMode} />
                </div>
                
                <div className="col-4 mb-3">
                    <label htmlFor="processed">Error </label>
                     <Dropdown filter showClear id="error" name="error" value={formik.values.error} onChange={formik.handleChange} optionLabel="name" optionValue='code' options={yesNoOptions} disabled={isViewMode} />
                </div>

                <div className="col-4 mb-3">
                    <label htmlFor="logText"> Log Text </label>
                    <InputText id="logText" name="logText" value={formik.values.logText} onChange={formik.handleChange} />
                </div>

              
                <div className="col-12 mb-2">
                    <label htmlFor="filePath">In File Path {isViewMode && <DownloadFile filePath={formik.values.inFilePath} toast={toast} />}</label>
                    <InputTextarea autoResize id="filePath" name="filePath" rows={2} value={formik.values.inFilePath} onChange={formik.handleChange} readOnly={isViewMode} />
                </div>

                <div className="col-12 mb-3">
                    <label htmlFor="outfilePath">Out File Path {isViewMode && <DownloadFile filePath={formik.values.outFilePath} toast={toast} />} </label>
                    <InputTextarea autoResize id="outFilePath" name="outFilePath" rows={2} value={formik.values.outFilePath} onChange={formik.handleChange} readOnly={isViewMode} />
                </div>

                 {(isEditMode || isViewMode) && (
                    <>
                        <div className="col-4 mb-3">
                            <label htmlFor="createdOn">Created On </label>
                            <InputText id="createdOn" name="createdOn" value={formik.values.createdOn} onChange={formik.handleChange} disabled />
                        </div>
                        <div className="col-4 mb-3">
                            <label htmlFor="lastUpdated">Last Updated </label>
                            <InputText id="lastUpdated" name="lastUpdated" value={formik.values.lastUpdated} onChange={formik.handleChange} disabled />
                        </div>
                        <div className="col-4 mb-3">
                            <label htmlFor="lastUpdatedBy">Last Updated By</label>
                            <InputText id="lastUpdatedBy" name="lastUpdatedBy" value={formik.values.lastUpdatedBy} onChange={formik.handleChange} disabled />
                        </div>
                    </>
                )}
                
            </div>
        );
    };

    const renderMainButton = () => {
        return (
            <>
                {!isViewMode &&
                    <Button
                        label={isEditMode ? 'Update' : 'Save'}
                        className="p-button-success tp"
                        data-pr-tooltip={isEditMode ? 'Update' : 'Save'}
                        icon="pi pi-save" type="submit"
                        severity="success" outlined
                    />
                }

                <Button
                  label={isViewMode ? 'Back' : 'Cancel'}
                  icon={isViewMode ? 'pi pi-arrow-left' : 'pi pi-times'}
                    severity="secondary" outlined
                     data-pr-tooltip={isViewMode ? 'Back' : 'Cancel'}
                  className="p-button-secondary tp" type="button"
                  onClick={() => navigate('/ui/int-outbound-file')}
                />
            </>
        );
    };

    // const handleRedirect = () => {
    //     dispatch(appActions.INTOUTBOUNDFILE_RESET_REQUEST());
    //     navigate('/ui/int-outbound-file', { replace: true });
    // };

    return (
        <>
            <Toast ref={toast} />
            <form onSubmit={formik.handleSubmit}>
                <div className="form_height px-2 mt-2">
                    <div className="d-flex flex-row gap-10 align-items-center mb-1">
                        <h2 className="page-header mr-auto"> {isEditMode ? 'Edit Integration Outbound File' : 'Integration Outbound File Details'} </h2>
                        {renderMainButton()}
                    </div>
                    <div className="grid px-2">
                        <div className="col-9">{renderFormArea()}</div>
                        <div className="col-3 px-3">
                            <div className="p-fluid formgrid grid br-2 bg-white py-4 border-round-xl shadow-1">
                                <div className="col-12 mb-2">
                                    <label htmlFor="status">Status</label>
                                    <Dropdown filter showClear id="status" name="status" value={formik.values.status} onChange={formik.handleChange} options={statusOptions} optionLabel="name" placeholder="Select" disabled={isViewMode} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default IntOutBoundFileDetail;
